import React, { FC, useEffect } from 'react';
import { env } from '@hb/hbridge';
import { downLoadApp, getOssImageUrl, getUrlParams } from '@/utils/utils';
import { WXSDK } from '@/utils/asyncImportJs';
import { useWxJsConfigSignature } from '@/models/appDownloadModel';
import { DOWNLOAD_IMG, TOPIC_IMG } from '@/constants/config';
import './index.less';

const CommonShareComponent: FC<{}> = () => {
  const { wxJsConfigSignature, getWxJsConfigSignature } = useWxJsConfigSignature();
  const { h5Url = '', title = '' } = getUrlParams(
    (window.location.href || '').replace(/#\//g, ''),
  ) as any;
  const initWxShare = () => {
    if (wxJsConfigSignature?.signature) {
      const { nonceStr, signature, timestamp } = wxJsConfigSignature || {};

      WXSDK().then((value) => {
        wx?.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: 'wx4e9cc6da9aa26fa9', // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
          // openTagList: ['wx-open-launch-app'],
        });
        wx?.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.updateAppMessageShareData({
            title: title || '邀请你一起关爱流浪猫', // 分享标题
            desc: '快来看看吧~', // 分享描述
            link: window.location.href || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: DOWNLOAD_IMG.INTRO_VIDEO, // 分享图标
            success() {
              // 设置成功
              console.log('wxJsConfigSignature', wxJsConfigSignature);
            },
            cancel() {
              console.log('分享取消');
            },
          });
          wx.updateTimelineShareData({
            title: title || '邀请你一起关爱流浪猫', // 分享标题
            desc: '快来看看吧', // 分享描述
            link: window?.location?.href || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: DOWNLOAD_IMG.INTRO_VIDEO, // 分享图标
            success() {
              // 设置成功
            },
            cancel() {
              console.log('分享取消');
            },
          });
        });
        wx?.error((res: any) => {
          // setIsReady(true);
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      });
    }
  };

  useEffect(() => {
    initWxShare();
  }, [wxJsConfigSignature]);

  useEffect(() => {
    if (env.isWeixin) {
      getWxJsConfigSignature();
    }
    return () => {};
  }, []);
  return (
    <div className="common-share">
      <div className="common-share-header">
        <div className="header-con">
          <img
            className="header-con-img"
            src={getOssImageUrl(TOPIC_IMG.APP_ICON, 64, 64)}
          />
          <div className="header-con-right">
            <div className="header-con-intro">
              <div
                className="header-con-intro-t"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                街猫APP
              </div>
              <div className="header-con-intro-b">流浪猫云喂养绝育领养</div>
            </div>
            <div
              className="download-btn"
              id="download-btn-header"
              onClick={() =>
                downLoadApp({
                  data: {},
                  clipboardStr: '',
                  selector: '#footer-btn',
                })
              }
            >
              打开看看
            </div>
          </div>
        </div>
      </div>
      <iframe className="common-share-iframe" src={h5Url}></iframe>
      {/* <div
        className="share-button-fixed"
        id="share-group-btn"
        onClick={() => {
          downLoadApp({
            data: {},
            clipboardStr: '',
            selector: '#footer-btn',
          });
        }}
      >
        <img
          className="share-button-icon"
          src={getOssImageUrl(TOPIC_IMG.APP_BOTTOM, 56, 56)}
        />
        App&nbsp;内打开
      </div> */}
    </div>
  );
};

export default CommonShareComponent;
